module.exports = __webpack_public_path__ + "img/ticket-line.6845f6c9.svg";